import type { TokenizedWord } from "@/lib/types";
import { TokenCard } from "./TokenCard";

interface SentenceTokenViewProps {
  tokens: TokenizedWord[];
  onCharacterClick?: (character: string) => void;
}

export function SentenceTokenView({ tokens, onCharacterClick }: SentenceTokenViewProps) {
  if (tokens.length === 0) {
    return null;
  }

  return (
    <div className="w-full flex flex-col items-center">
      <div className="w-4/5">
        <div className="text-sm text-muted-foreground mb-3">
          Sentence breakdown ({tokens.length} word{tokens.length !== 1 ? "s" : ""}):
        </div>
        <div className="flex flex-col gap-3">
          {tokens.map((token, i) => (
            <TokenCard
              key={`${token.startIndex}-${i}`}
              token={token}
              onCharacterClick={onCharacterClick}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
